"use client";

import { useEffect, useState } from "react";
import { Cursor, useTypewriter } from "react-simple-typewriter";

interface TypewriterTextProps {
  prefix: string;
  words: readonly string[] | string[];
  suffix: string;
  /** Shown when prefers-reduced-motion: reduce (no cycling). */
  staticWord?: string;
}

const TypewriterText = ({
  prefix,
  words,
  suffix,
  staticWord,
}: TypewriterTextProps) => {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setReduceMotion(media.matches);
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, []);

  const wordList = [...words];
  const [text] = useTypewriter({
    words: wordList,
    loop: true,
    delaySpeed: 2000,
    deleteSpeed: 50,
    typeSpeed: 100,
  });

  const displayWord = reduceMotion ? (staticWord ?? wordList[0] ?? "") : text;

  return (
    <h1 className="flex flex-col items-center justify-center text-3xl md:text-4xl lg:text-5xl font-bold text-center leading-tight gap-1 md:gap-2">
      <span className="block">{prefix}</span>
      <span className="block text-[#009306] bg-yellow-300 rounded-xl pb-1 pl-3 pr-1">
        {displayWord}
        {!reduceMotion ? <Cursor cursorStyle="|" /> : null}
      </span>
      <span className="block">{suffix}</span>
    </h1>
  );
};

export default TypewriterText;
